import { render } from "./Heads.vue?vue&type=template&id=cc3c3cba&scoped=true"
import script from "./Heads.vue?vue&type=script&lang=js"
export * from "./Heads.vue?vue&type=script&lang=js"

import "./Heads.vue?vue&type=style&index=0&id=cc3c3cba&lang=less&scoped=true"

import exportComponent from "/data/webcode/iotopenplattform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc3c3cba"]])

export default __exports__